import React, { useMemo } from 'react';
import { Tooltip } from '@fluentui/react-components';

function formatParts(date, timeZone) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(date).reduce((accumulator, part) => {
    if (part.type !== 'literal') {
      accumulator[part.type] = part.value;
    }
    return accumulator;
  }, {});

  const zone = parts.timeZoneName ? ` ${parts.timeZoneName}` : '';
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}${zone}`;
}

export function TimezoneDateTime({ value, displayTimeZone = 'America/Los_Angeles', className }) {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

  const parsedDate = useMemo(() => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }, [value]);

  const formattedValue = useMemo(() => {
    if (!parsedDate) return '';
    return formatParts(parsedDate, displayTimeZone);
  }, [parsedDate, displayTimeZone]);

  const tooltipContent = useMemo(() => {
    if (!parsedDate) return '';
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <div>UTC: {formatParts(parsedDate, 'UTC')}</div>
        <div>Local: {formatParts(parsedDate, localTimeZone)}</div>
      </div>
    );
  }, [parsedDate, localTimeZone]);

  if (!parsedDate) {
    return <span className={className}>{value ? String(value) : ''}</span>;
  }

  return (
    <Tooltip content={tooltipContent} relationship="description">
      <span className={className} style={{ whiteSpace: 'nowrap' }}>
        {formattedValue}
      </span>
    </Tooltip>
  );
}

export default TimezoneDateTime;